import React from 'react';

const MainTabPanel = ({ active, children, className = '' }) => {
  if (!active) {
    return null;
  }

  return (
    <section className={`tab-content active ${className}`.trim()}>
      <div className="inner">{children}</div>
    </section>
  );
};

export default MainTabPanel;
